import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  TextField, MenuItem, Stack, Typography, Alert
} from '@mui/material';
import PropTypes from 'prop-types';
import { addCategory } from '../../services/categoryServices';

const InsertCategoryDialog = ({ open, onClose, onSuccess, parentCategories }) => {
  const [formData, setFormData] = useState({
    nome: '',
    parentId: '',
    prezzoPpc: '',
    inizioValidita: new Date().toISOString().split('T')[0],
    fineValidita: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'nome') {
      const filteredValue = value.replaceAll(/[^a-zA-ZàèéìòùÀÈÉÌÒÙ\s']/g, '');
      setFormData({ ...formData, [name]: filteredValue });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async () => {
    if (!formData.nome.trim()) {
      setError("Il nome della categoria è obbligatorio.");
      return;
    }
    const nameRegex = /^[a-zA-ZàèéìòùÀÈÉÌÒÙ\s']+$/;
    if (!nameRegex.test(formData.nome.trim())) {
      setError("Il nome della categoria contiene caratteri non validi (ammessi solo lettere, spazi e apostrofi).");
      return;
    }

    if (formData.prezzoPpc && Number.parseFloat(formData.prezzoPpc) < 0) {
      setError("Il costo PPC non può essere negativo.");
      return;
    }

    setLoading(true);
    setError('');
    try {
      const request = {
        nome: formData.nome.trim(),
        parentId: formData.parentId || null,
        prezzoPpc: formData.prezzoPpc ? Number.parseFloat(formData.prezzoPpc) : null,
        inizioValidita: formData.inizioValidita || null,
        fineValidita: formData.fineValidita || null
      };
      await addCategory(request);
      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ backgroundColor: '#0b3d87', color: 'white', fontWeight: 'bold' }}>
        Aggiungi Nuova Categoria
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Stack spacing={3} sx={{ mt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="Nome Categoria"
            name="nome"
            fullWidth
            required
            value={formData.nome}
            onChange={handleChange}
          />
          <TextField
            select
            label="Categoria Padre"
            name="parentId"
            fullWidth
            value={formData.parentId}
            onChange={handleChange}
          >
            <MenuItem value="">Nessuna (Macro-categoria)</MenuItem>
            {Array.isArray(parentCategories) && parentCategories.map(cat => (
              <MenuItem key={cat.categoryId} value={cat.categoryId}>{cat.nome}</MenuItem>
            ))}
          </TextField>
          
          <Stack direction="row" spacing={2}>
            <TextField
              label="Costo PPC (€)"
              name="prezzoPpc"
              type="number"
              fullWidth
              value={formData.prezzoPpc}
              onChange={handleChange}
              slotProps={{ htmlInput: { step: "0.01" } }}
            />
          </Stack>

          <Stack direction="row" spacing={2}>
            <TextField
              label="Inizio Validità"
              name="inizioValidita"
              type="date"
              fullWidth
              value={formData.inizioValidita}
              onChange={handleChange}
              slotProps={{ inputLabel: { shrink: true } }}
            />
            <TextField
              label="Fine Validità"
              name="fineValidita"
              type="date"
              fullWidth
              value={formData.fineValidita}
              onChange={handleChange}
              slotProps={{ inputLabel: { shrink: true } }}
            />
          </Stack>

          <Typography variant="caption" color="text.secondary">
            Nota: I dati inseriti verranno validati in tempo reale dal sistema.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose} color="inherit">Annulla</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading}
          sx={{ backgroundColor: '#0b3d87', fontWeight: 'bold' }}
        >
          {loading ? 'Inserimento...' : 'Conferma Inserimento'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

InsertCategoryDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  parentCategories: PropTypes.arrayOf(PropTypes.shape({
    categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nome: PropTypes.string
  }))
};

export default InsertCategoryDialog;
 